/** A page visit survives transient reconnects; a new page creates a new boundary.
 * IDs, rather than client timestamps, avoid server/device clock skew.
 * The first successful snapshot is the history present when this visit loads.
 */
export class ChatVisit {
  private archivedIds: Set<string> | null = null;

  split<T extends { id: string }>(messages: readonly T[]): { current: T[]; archive: T[] } {
    this.archivedIds ??= new Set(messages.map(message => message.id));
    return {
      current: messages.filter(message => !this.archivedIds!.has(message.id)),
      archive: messages.filter(message => this.archivedIds!.has(message.id)),
    };
  }
}
